export default __webpack_public_path__ + "static/media/2.b05caaa9.jpg";